import { atom } from 'jotai';
import { MapData_Base, MapData_GetList_Response } from '~/common/typescript/models/MapData';

export const showLibraryPanelAtom = atom<boolean>(false);

export interface LibraryFilters {
  searchText: string;
  dataTypes: string[];
  categories: string[];
  statuses: string[];
  ownerId: string | null;
  dateRange: [any, any] | null;
}

export const libraryFiltersAtom = atom<LibraryFilters>({
  searchText: '',
  dataTypes: [],
  categories: [],
  statuses: [],
  ownerId: null,
  dateRange: null,
});

// Extended interface for library map data
export type LibraryMapData = MapData_Base;

export const libraryLayersAtom = atom<LibraryMapData[]>([]);

// Pagination and loading state
export const libraryPaginationAtom = atom<{
  page: number;
  pageSize: number;
  total: number;
  hasMore: boolean;
}>({
  page: 1,
  pageSize: 20,
  total: 0,
  hasMore: true,
});

export const libraryLoadingAtom = atom<boolean>(false);

export const libraryErrorAtom = atom<string | null>(null);

// Preview modal state
export const showLibraryPreviewAtom = atom<boolean>(false);
